import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, Calendar, X } from 'lucide-react';
import FixedFooter from '@/components/common/FixedFooter';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const UpcomingEventsPage = () => {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    fetchEvents();
  }, []);

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${API}/events`);
      setEvents(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching events:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div
            className="animate-spin rounded-full h-12 w-12 border-b-2 mx-auto mb-4"
            style={{ borderColor: 'var(--burgundy)' }}
          ></div>
          <p style={{ color: 'var(--charcoal)' }}>Loading events...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen  flex items-between flex-col gap-4 ">
      <div className="">
        {/* Header */}
        <header
          className="sticky top-0 z-40 glass-burgundy border-b"
          style={{ borderColor: 'rgba(224, 178, 59, 0.2)' }}
        >
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex items-center justify-between">
              <button
                onClick={() => navigate('/')}
                className="flex items-center gap-2 text-burgundy hover:opacity-80"
                style={{ color: 'var(--burgundy)' }}
              >
                <ArrowLeft size={20} />
                <span>Home</span>
              </button>

              <div className="flex items-center gap-2">
                <Calendar size={24} style={{ color: 'var(--burgundy)' }} />
                <h1
                  className="text-xl font-semibold"
                  style={{ color: 'var(--burgundy)' }}
                >
                  Upcoming Events
                </h1>
              </div>

              <div></div>
            </div>
          </div>
        </header>

        {/* Events Grid */}
        <main className="max-w-7xl mx-auto px-4 py-8">
          {events.length === 0 ? (
            <div className="text-center py-20">
              <Calendar
                size={64}
                className="mx-auto mb-4 opacity-50"
                style={{ color: 'var(--charcoal)' }}
              />
              <p
                className="text-xl mb-2"
                style={{ color: 'var(--charcoal)' }}
              >
                No upcoming events
              </p>
              <p
                className="text-sm opacity-70"
                style={{ color: 'var(--charcoal)' }}
              >
                Check back later for exciting events!
              </p>
            </div>
          ) : (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {events.map((event) => (
                <div
                  key={event.id}
                  className="glass rounded-2xl overflow-hidden hover:shadow-xl"
                >
                  <img
                    src={`${BACKEND_URL}${event.image_url}`}
                    alt={event.title}
                    className="w-full h-64 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                    onClick={() =>
                      setSelectedImage({
                        url: `${BACKEND_URL}${event.image_url}`,
                        title: event.title,
                      })
                    }
                  />
                  <div className="p-4">
                    <h3
                      className="text-lg font-semibold"
                      style={{ color: 'var(--burgundy)' }}
                    >
                      {event.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          )}
        </main>

        {/* Image Modal */}
        {selectedImage && (
          <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <button
                onClick={() => setSelectedImage(null)}
                className="absolute -top-10 right-0 text-white hover:text-gray-300 z-10"
              >
                <X size={32} />
              </button>
              <img
                src={selectedImage.url}
                alt={selectedImage.title}
                className="max-w-full max-h-full object-contain rounded-lg"
                onClick={(e) => e.stopPropagation()}
              />
            </div>
          </div>
        )}
      </div>

      {/* Fixed Footer */}
     <div className='mt-40'>
      <FixedFooter />
</div>
    </div>
  );
};

export default UpcomingEventsPage;
